import { render, staticRenderFns } from "./CleavePhone.vue?vue&type=template&id=d2ba4978&"
import script from "./CleavePhone.vue?vue&type=script&lang=js&"
export * from "./CleavePhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports